module.exports = __webpack_public_path__ + "img/onboarding2.3a5f86ec.jpg";